<div class="container view-plans-page">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }

  <div class="grid container-header view-plans-header">
    <div class="col-12 md:col-6 header-title-col">
      <span class="title">{{ 'TRANSLATE.CONSULT' | translate }}</span>
    </div>
    <div class="col-12 md:col-6 header-action-col">
      <div class="new-plans">
        <p-dropdown [(ngModel)]="selectedNewPlans" [options]="bottonItems" id="newPlans" name="newPlans"
          placeholder="{{ 'TRANSLATE.ADD' | translate }}" (onChange)="changeLang($event.value?.label)">
          <ng-template let-item pTemplate="selectedItem">
            @if (item?.icon) {
            <i class="{{item?.icon}} new-plans-i"></i>
            }
            <span class="new-plans-label">
              {{ item?.label || ('TRANSLATE.ADD' | translate) }}
            </span>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="container-body">
    <div class="search-filters-wrapper">
      <p-accordion>
        <p-accordionTab header="Filtros" styleClass="filters-tab" [selected]="true">
          <div class="ui-fluid filters-grid">
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="typeQueryNew">{{ 'TRANSLATE.TYPE.QUERY' | translate }}</label>
              <p-dropdown id="typeQueryNew" [(ngModel)]="selectTypePlan" [options]="statusPlan"
                (onChange)="generalSearch()" appendTo="body" [style]="{'minWidth':'100%'}">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item?.label | translate}}
                </ng-template>
              </p-dropdown>
            </div>

            @if (selectTypePlan !== 'Preço') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="countryNew">{{ 'TRANSLATE.COUNTRY' | translate }}</label>
              <p-multiSelect #countryMultiSelect id="countryNew" [placeholder]="selectPlaceholder"
                [(ngModel)]="selectedCountries" appendTo="body" [placeholder]="selectPlaceholder"
                [options]="countriesList" [maxSelectedLabels]="2" (onChange)="countryChange($event)"
                (onPanelHide)="countrySelectionPanelHide()" [style]="{'minWidth':'100%','minHeight':'33px'}"
                aria-required="true">
              </p-multiSelect>
              @if (selectedCountries.length === 0) {
              <small class="field-hint">
                {{ 'TRANSLATE.SELECT.COUNTRY.FIRST' | translate }}
              </small>
              }
            </div>
            }

            @if (selectTypePlan !== 'Preço' ) {
            <div class="col-12 md:col-6 lg:col-6 selected-edit">
              @if (selectTypePlan === 'Produto') {
              <label class="selected-edit-title" for="productNameNew">
                {{ 'TRANSLATE.ID.PRODUCT.NAME' | translate }}
              </label>
              }
              @if (selectTypePlan === 'Cobertura') {
              <label class="selected-edit-title" for="productNameNew">
                {{ 'TRANSLATE.ID.COVERAGE.NAME.VIEW' | translate }}
              </label>
              }
              @if (selectTypePlan === 'Elegibilidade') {
              <label class="selected-edit-title" for="productNameNew">
                {{ 'TRANSLATE.ID.PRODUCT.NAME' | translate }}
              </label>
              }
              <p-multiSelect #productNameMultiSelect id="productNameNew" [placeholder]="selectPlaceholder"
                [options]="products" appendTo="body" [placeholder]="selectPlaceholder" [(ngModel)]="product"
                optionLabel="name" [maxSelectedLabels]="1" [filterBy]="'id,name'" [disabled]="secondaryFiltersDisabled"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(productNameMultiSelect)"
                (onPanelHide)="cancelMultiSelectPanelClose(productNameMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px','maxLength':'677px'}" aria-required="true">
                <ng-template pTemplate="item" let-item>
                  {{ formatProductIdName(item) }}
                </ng-template>
                <ng-template pTemplate="selectedItems" let-values>
                  @if (values?.length > 0 && !secondaryFiltersDisabled) {
                  <span>{{ formatProductIdName(values[0]) }}</span>
                  }
                </ng-template>
              </p-multiSelect>
            </div>
            }


            @if (selectTypePlan === 'Produto') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="productSymbolNew">{{ 'TRANSLATE.PRODUCT.SYMBOL' | translate
                }}</label>
              <p-multiSelect #productSymbolMultiSelect id="productSymbolNew" [placeholder]="selectPlaceholder"
                [options]="products" appendTo="body" [placeholder]="selectPlaceholder" [(ngModel)]="product"
                [maxSelectedLabels]="3" optionLabel="productCode" [disabled]="secondaryFiltersDisabled"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(productSymbolMultiSelect)"
                (onPanelHide)="cancelMultiSelectPanelClose(productSymbolMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Cobertura') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="coverageNew">{{ 'TRANSLATE.COVERAGE' | translate }}</label>
              <p-multiSelect #coverageMultiSelect id="coverageNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" [maxSelectedLabels]="1"
                optionLabel="owsCategory" [disabled]="secondaryFiltersDisabled"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(coverageMultiSelect)"
                (onPanelHide)="cancelMultiSelectPanelClose(coverageMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="saleTypeNew">{{ 'TRANSLATE.SALE.TYPE' | translate }}</label>
              <p-multiSelect #saleTypeMultiSelect id="saleTypeNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" optionLabel="saleType"
                [disabled]="secondaryFiltersDisabled" (onPanelHide)="cancelMultiSelectPanelClose(saleTypeMultiSelect)"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(saleTypeMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="statusNew">{{ 'TRANSLATE.STATUS' | translate }}</label>
              <p-multiSelect #statusMultiSelect id="statusNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" [maxSelectedLabels]="1"
                optionLabel="statusCode" [filterBy]="'statusCode,statusSearchText'" filterMatchMode="startsWith"
                [disabled]="secondaryFiltersDisabled"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(statusMultiSelect)"
                (onPanelHide)="cancelMultiSelectPanelClose(statusMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
                <ng-template pTemplate="item" let-item>
                  {{ getLocalizedStatusLabel(item?.statusCode) }}
                </ng-template>
                <ng-template pTemplate="selectedItems" let-values>
                  @if (values?.length > 0 && values[0]?.statusCode) {
                  <span>{{ getLocalizedStatusLabel(values[0]?.statusCode) }}</span>
                  }
                </ng-template>
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Preço') {
            <div class="col-12 md:col-3 lg:col-3 selected-edit">
              <label class="selected-edit-title" for="priceTypeNew">{{ 'TRANSLATE.PRICE.TYPE' | translate }}</label>
              <p-multiSelect #priceTypeMultiSelect id="priceTypeNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [(ngModel)]="selectedPriceTypes" appendTo="body" [options]="priceTypeOptions" [maxSelectedLabels]="2"
                (onPanelHide)="cancelMultiSelectPanelClose(priceTypeMultiSelect)"
                (onChange)="priceTypeChange($event); scheduleMultiSelectPanelClose(priceTypeMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Preço') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="currencyNew">{{ 'TRANSLATE.CURRENCY' | translate }}</label>
              <p-multiSelect #currencyMultiSelect id="currencyNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [(ngModel)]="selectedCurrencies" appendTo="body" [options]="currencyOptions" [maxSelectedLabels]="2"
                (onPanelHide)="cancelMultiSelectPanelClose(currencyMultiSelect)"
                (onChange)="currencyChange($event); scheduleMultiSelectPanelClose(currencyMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="modelNew">{{ 'TRANSLATE.MODEL' | translate }}</label>
              <p-multiSelect #modelMultiSelect id="modelNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" [maxSelectedLabels]="1"
                optionLabel="vehicleLineN" [disabled]="secondaryFiltersDisabled"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(modelMultiSelect)"
                (onPanelHide)="cancelMultiSelectPanelClose(modelMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="yearNew">{{ 'TRANSLATE.YEAR' | translate }}</label>
              <p-multiSelect #yearMultiSelect id="yearNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" optionLabel="modelYear"
                [disabled]="secondaryFiltersDisabled" (onPanelHide)="cancelMultiSelectPanelClose(yearMultiSelect)"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(yearMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-4 selected-edit">
              <label class="selected-edit-title" for="vehicleLineNew">{{ 'TRANSLATE.VEHICLE.LINE' | translate }}</label>
              <p-multiSelect #vehicleLineMultiSelect id="vehicleLineNew"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [options]="products" appendTo="body"
                [(ngModel)]="product" optionLabel="vehicleLineC" [disabled]="secondaryFiltersDisabled"
                (onPanelHide)="cancelMultiSelectPanelClose(vehicleLineMultiSelect)"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(vehicleLineMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }

            @if (selectTypePlan === 'Elegibilidade') {
            <div class="col-12 md:col-3 lg:col-2 selected-edit">
              <label class="selected-edit-title" for="tmaNew">{{ 'TRANSLATE.TMA' | translate }}</label>
              <p-multiSelect #tmaMultiSelect id="tmaNew" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
                [options]="products" appendTo="body" [(ngModel)]="product" optionLabel="tma"
                [disabled]="secondaryFiltersDisabled" (onPanelHide)="cancelMultiSelectPanelClose(tmaMultiSelect)"
                (onChange)="productChange($event); scheduleMultiSelectPanelClose(tmaMultiSelect)"
                [style]="{'minWidth':'100%','minHeight':'33px'}" aria-required="true">
              </p-multiSelect>
            </div>
            }
          </div>

          <div class="button-position">
            <button [disabled]="loadingPlans" class="action-button-clean margin-btn-right app-clean-button"
              type="button" (click)="clearSearchFilter()">
              <i class="pi pi-trash"></i>
              <span class="action-button-clean-label">{{ 'TRANSLATE.BNT.CLEAR' | translate }}</span>
            </button>

            <button [disabled]="searchButtonDisabled" class="btn-search margin-btn app-filter-button" type="button"
              (click)="validateSearch()">
              @if (!filterButtonLoading) {
              <i class="pi pi-filter"></i>
              }
              @if (filterButtonLoading) {
              <i class="pi pi-spin pi-spinner"></i>
              }
              <span class="btn-search-label">{{ (filterButtonLoading ? 'TRANSLATE.BNT.FILTERING' :
                'TRANSLATE.BNT.FILTER') | translate }}</span>
            </button>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>

    <div class="search-results">

      @if (selectTypePlan === 'Produto') {
      <div class="col-12">
        <p-table #tabela id="excel-table-product" [value]="selectedProductsResult" [paginator]="true" [rows]="20"
          styleClass="product-results-table app-table app-table--wide app-table--condensed app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5"
                style="text-align: left !important; position: static !important; right: auto !important; box-shadow: none !important;">
                {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'TRANSLATE.COUNTRY' | translate }}</th>
              <th>{{ 'TRANSLATE.PRODUCT.SYMBOL' | translate }}</th>
              <th class="product-name-col">{{ 'TRANSLATE.PRODUCT.NAME' | translate }}</th>
              <th>{{ 'TRANSLATE.VISIT' | translate }}</th>
              <th class="actions-col-header">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="results-row">
              <td>{{ rowData.country }}</td>
              <td>{{ rowData.productCode }}</td>
              <td class="product-name-col">
                <span class="app-cell-clamp-2" [title]="rowData.name">{{ rowData.name }}</span>
              </td>
              <td>{{ rowData.visit }}</td>
              <td class="actions-col">
                <div class="actions-col-content">
                  <button type="button" class="table-action-btn" (click)="editProductButton(rowData.id)">
                    {{ 'TRANSLATE.VIEW' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }

      @if (selectTypePlan === 'Cobertura') {
      <div class="col-12">
        <p-table #tabela id="excel-table-coverage" [value]="selectedProductsResult" [paginator]="true" [rows]="20"
          styleClass="coverage-results-table app-table app-table--wide app-table--condensed app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6"
                style="text-align: left !important; position: static !important; right: auto !important; box-shadow: none !important;">
                {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'TRANSLATE.COUNTRY' | translate }}</th>
              <th class="product-name-col">{{ 'TRANSLATE.PRODUCT.NAME' | translate }}</th>
              <th>{{ 'TRANSLATE.MONTHS' | translate }}</th>
              <th>{{ 'TRANSLATE.MILEAGE' | translate }}</th>
              <th>{{ 'TRANSLATE.COVERAGE.OWS' | translate }}</th>
              <th class="actions-col-header">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="results-row">
              <td>{{ rowData.country }}</td>
              <td class="product-name-col">
                <span class="app-cell-clamp-2" [title]="rowData.name">{{ rowData.name }}</span>
              </td>
              <td>{{ rowData.term }}</td>
              <td>{{ rowData.distance | number: '1.0-0' }}</td>
              <td>{{ rowData.owsCategory }}</td>
              <td class="actions-col">
                <div class="actions-col-content">
                  <button type="button" class="table-action-btn" (click)="editCoverageButton(rowData.id)">
                    {{ 'TRANSLATE.VIEW' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }

      @if (selectTypePlan === 'Preço') {
      <div class="col-12">
        <p-table #tabela id="excel-table-coverage" [value]="selectedProductsResult" [paginator]="true" [rows]="20"
          styleClass="price-results-table app-table app-table--wide app-table--condensed app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5"
                style="text-align: left !important; position: static !important; right: auto !important; box-shadow: none !important;">
                {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'TRANSLATE.NAME' | translate }}</th>
              <th class="price-description-col">{{ 'TRANSLATE.DESCRIPTION' | translate }}</th>
              <th>{{ 'TRANSLATE.CURRENCY' | translate }}</th>
              <th>{{ 'TRANSLATE.VALUE' | translate }}</th>
              <th class="actions-col-header">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="results-row">
              <td>{{ rowData.itemName }}</td>
              <td class="price-description-col">
                <span class="app-cell-clamp-2" [title]="rowData.itemDescription">{{ rowData.itemDescription }}</span>
              </td>
              <td>{{ rowData.itemPriceUnit }}</td>
              <td>{{ rowData.formattedItemPrice }}</td>
              <td class="actions-col">
                <div class="actions-col-content">
                  <button type="button" class="table-action-btn" (click)="editPriceButton(rowData.id)">
                    {{ 'TRANSLATE.VIEW' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }

      @if (selectTypePlan === 'Elegibilidade') {
      <div class="col-12">
        <p-table #tabela id="excel-table-eligibility" [value]="selectedProductsResult" [paginator]="true" [rows]="20"
          styleClass="eligibility-table app-table app-table--wide app-table--condensed app-table--sticky-action">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9"
                style="text-align: left !important; position: static !important; right: auto !important; box-shadow: none !important;">
                {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="eligibility-col-country">{{ 'TRANSLATE.COUNTRY' | translate }}</th>
              <th class="eligibility-col-status">{{ 'TRANSLATE.STATUS' | translate }}</th>
              <th class="eligibility-col-product">{{ 'TRANSLATE.PRODUCT.NAME' | translate }}</th>
              <th class="eligibility-col-coverage">{{ 'TRANSLATE.COVERAGE' | translate }}</th>
              <th class="eligibility-col-vehicle">{{ 'TRANSLATE.MODEL.YEAR.VEHICLE.LINE.TMA' | translate }}</th>
              <th class="eligibility-col-description">{{ 'TRANSLATE.DESCRIPTION.ELIGIBILITY' | translate }}</th>
              <th class="eligibility-col-price">{{ 'TRANSLATE.SELECT.PRICE.CUSTOMER' | translate }}</th>
              <th class="eligibility-col-sale-type">{{ 'TRANSLATE.SALE.TYPE' | translate }}</th>
              <th class="eligibility-col-actions actions-col-header">{{ 'TRANSLATE.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr class="results-row">
              <td class="eligibility-col-country">{{ rowData.country }}</td>
              <td class="eligibility-col-status">{{ getLocalizedStatusLabel(rowData.statusCode) }}</td>
              <td class="eligibility-col-product">
                <span class="app-cell-clamp-2" [title]="rowData.name">{{ rowData.name }}</span>
              </td>
              <td class="eligibility-col-coverage">
                <span class="app-cell-clamp-2" [title]="rowData.visitsDurationDistance">{{
                  rowData.visitsDurationDistance }}</span>
              </td>
              <td class="eligibility-col-vehicle">{{ rowData.vehicleInformation }}</td>
              <td class="eligibility-col-description">
                <span class="app-cell-clamp-2" [title]="rowData.description">{{ rowData.description }}</span>
              </td>
              <td class="eligibility-col-price">{{ rowData.unityPrice }} {{ rowData.formattedCustomerPrice }}</td>
              <td class="eligibility-col-sale-type">{{ rowData.saleType }}</td>
              <td class="eligibility-col-actions actions-col">
                <div class="actions-col-content">
                  <button type="button" class="table-action-btn" (click)="editEligibilityButton(rowData.id)">
                    {{ 'TRANSLATE.VIEW' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
  </div>
</div>